<div class="row-wrapper registration-finished-column">
  <div nz-row>
    <div nz-col [nzSpan]="24" class="account-created-text">
      {{ 'NEW_ACCOUNT.ACCOUNT_CREATED' | translate }}
    </div>
  </div>
  <div nz-row>
    <div nz-col [nzSpan]="24">
      <p class="next-steps-explanation" [innerHTML]="'NEW_ACCOUNT.ACTIVATION_EXPLANATION' | translate"></p>
      <p class="close-page-info" [innerHTML]="'NEW_ACCOUNT.YOU_CAN_CLOSE_THIS_PAGE' | translate"></p>
    </div>
  </div>
</div>
